import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.consumerTitle,
      "subtitle": _vm.consumerDescr,
      "loader": "",
      "formIsValid": _vm.isIotHubManager,
      "saveButton": "",
      "cancelButton": ""
    },
    on: {
      "saveData": _vm.saveItem,
      "cancel": _vm.cancelEdit
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow pb-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": null
    }
  }, [_c('niota-classic-consumers-edit', {
    ref: "editedConsumer",
    attrs: {
      "consumerData": _vm.consumerData
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };